export default __webpack_public_path__ + "static/media/megaphone-emoji.b70d4733.png";